/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_CreditsInputs */

const en_settings_billing_credits = /** @type {(inputs: Settings_Billing_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const zh_settings_billing_credits = /** @type {(inputs: Settings_Billing_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`额度`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Settings_Billing_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_credits = /** @type {((inputs?: Settings_Billing_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_credits(inputs)
	return zh_settings_billing_credits(inputs)
});
export { settings_billing_credits as "settings.billing.credits" }